export default class StateManager {
    constructor() {
        this.actions = []
        this.currentIndex = -1;
    }

    addAction(action) {
        if( this.currentIndex < this.actions.length - 1 ) {
            let itemCount = this.actions.length - 1 - this.currentIndex
            this.actions.splice(this.currentIndex, itemCount)
        }

        this.currentIndex++;
        this.actions.push( action );
    }

    undoAvailable() {
        let previousActionsExist = this.actions.length > 0 && this.currentIndex > -1;
        return previousActionsExist;
    }

    redoAvailable() {
        let nextActionsExist = this.actions.length > 0 && this.currentIndex < this.actions.length - 1;
        return nextActionsExist;
    }

    undoNext() {
        let action = this.actions[this.currentIndex]
        action.undo();
        console.log( "StateManager, undoing " + action.toString() );
        this.currentIndex--;
    }

    redoNext() {
        this.currentIndex++;
        let action = this.actions[this.currentIndex]
        action.redo();
        console.log( "StateManager, redoing " + action.toString() );
    }

}